<template>
  <div class="reset-pwd">
    <nav-bar title="个人信息" />
    <div class="bd">
      <van-cell :center="true" is-link size="large" title="头像">
        <!-- 使用 right-icon 插槽来自定义右侧图标 -->
        <template #value>
          <zy-uploader
            v-model:file="form.Avatar"
            :limit-size="500 * 1024"
            :max-count="10"
            :max-size="10 * 1024 * 1024"
          />
        </template>
      </van-cell>
      <van-field
        v-model="form.NickName"
        input-align="right"
        is-link
        label="昵称"
        label-class="new-cell"
        name="NickName"
        placeholder="请填写昵称"
        size="large"
      />
      <div style="margin: 80px 16px 16px">
        <van-button
          block
          native-type="submit"
          round
          type="primary"
          @click="onSubmit"
        >
          确定
        </van-button>
      </div>
    </div>
  </div>
</template>
<script>
  import { ref, onMounted, getCurrentInstance } from 'vue'
  import NavBar from '@/components/NavBar'
  import { useRouter } from 'vue-router'
  import store from '@/store'
  import md5 from 'js-md5'
  import { Toast, Dialog, Notify } from 'vant'
  import ZyUploader from '@/components/ZyUploaderSimple'
  export default {
    components: {
      NavBar,
      ZyUploader,
    },
    setup() {
      const active = ref(0)
      const router = useRouter()
      const { proxy } = getCurrentInstance()
      const form = ref({
        Avatar: '',
      })

      onMounted(async () => {
        await store.dispatch('user/getUserInfo')
        const userInfo = store.getters['user/getUserInfo']
        form.value = Object.assign(form.value, userInfo)
      })

      const onSubmit = async (values) => {
        const tenant = await store.getters['user/getTenant']
        const params = JSON.parse(JSON.stringify(form.value))
        params.TenantId = tenant.TenantId
        store
          .dispatch('user/UserUpdateUserInfo', params)
          .then(async (data) => {
            await store.dispatch('user/getUserInfo')
            Toast('修改成功！')
          })
          .catch((e) => {
            Toast(e.Message)
            console.log(e)
          })
        // setTimeout(async () => {
        //   await store
        //     .dispatch('user/UserUpdateAvatar', {
        //       avatarUrl: form.value.Avatar,
        //     })
        //     .then(async (data) => {
        //       await store.dispatch('user/getUserInfo')
        //     })
        //     .catch((e) => {
        //       Notify(e.Message)
        //       console.log(e)
        //     })
        // }, 500)
      }

      return {
        active,
        form,
        onSubmit,
      }
    },
  }
</script>
<style lang="scss" scoped>
  .reset-pwd {
    background: #fff;
    padding-bottom: 20px;
    padding-top: 64px;
    .hd {
      padding: 10px 70px;
    }
    ::v-deep .new-cell {
      color: #333;
    }
  }
</style>
